export default __webpack_public_path__ + "static/GT-America-Extended-Bold-1fbbea2d7530b5fa5224290f4d7e3025.ttf";